import { AxiosResponse } from 'axios';
import { SET_PROJECT_EMPLOYEES, SET_PROJECT_EMPLOYEE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_PROJECT_EMPLOYEE_ISLOADING,
  DELETE_PROJECT_EMPLOYEE,
  EDIT_PROJECT_EMPLOYEE,
  GET_PROJECT_EMPLOYEES,
  GET_PROJECT_EMPLOYEE,
  REGISTER_PROJECT_EMPLOYEE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import ProjectEmployee from '@/services/project_employee';
import { Module } from 'vuex';
import { EditProjectEmployee, RegisterProjectEmployee, GetProjectEmployee } from '@/dtos/project_employee.dto';

const projectEmployee: Module<any, {}> = {
  state: {
    projectEmployee: {
      data: null,
      isLoading: false,
    },
    projectEmployees: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    projectEmployee: (state: { projectEmployee: any }) => state.projectEmployee,
    projectEmployees: (state: { projectEmployees: any }) => state.projectEmployees,
  },
  mutations: {
    [SET_PROJECT_EMPLOYEE]: (
      state: { projectEmployee: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.projectEmployee.data = payload.data) : null,
        (state.projectEmployee.isLoading = payload.isLoading);
    },
    [SET_PROJECT_EMPLOYEES]: (
      state: { projectEmployees: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.projectEmployees.data = payload.data) : null,
        (state.projectEmployees.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_PROJECT_EMPLOYEE]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_EMPLOYEE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectEmployee.registerProjectEmployee(
        payload as RegisterProjectEmployee
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PROJECT_EMPLOYEE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_EMPLOYEE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_EMPLOYEE, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECT_EMPLOYEES]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_EMPLOYEES, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectEmployee.getProjectEmployees(
        payload as GetProjectEmployee
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_EMPLOYEES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_EMPLOYEES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_EMPLOYEES, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECT_EMPLOYEE]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_EMPLOYEE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectEmployee.getProjectEmployees(
        payload as GetProjectEmployee
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_EMPLOYEE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_PROJECT_EMPLOYEE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_EMPLOYEE, { isLoading: false });
        return false;
      }
    },
    [EDIT_PROJECT_EMPLOYEE]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_EMPLOYEE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectEmployee.editProjectEmployee(
        payload as EditProjectEmployee
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_EMPLOYEE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_EMPLOYEE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_EMPLOYEE, { isLoading: false });
        return false;
      }
    },
    [DELETE_PROJECT_EMPLOYEE]: async ({ commit }: any, payload: string) => {
      commit(SET_PROJECT_EMPLOYEE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectEmployee.deleteProjectEmployee(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_EMPLOYEE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_EMPLOYEE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_EMPLOYEE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_PROJECT_EMPLOYEE_ISLOADING]: ({ commit }) => {
      commit(SET_PROJECT_EMPLOYEE, { isLoading: false });
      commit(SET_PROJECT_EMPLOYEES, { isLoading: false });
    },
  },
};

export default projectEmployee;

